import { FC } from 'react';
import { useAssetType } from 'src/context-providers/asset-type/AssetTypeContext';

interface Props {
  IfRealEstate: React.ComponentType<any>;
  IfPowerplant: React.ComponentType<any>;
  IfPlot: React.ComponentType<any>;
  children: JSX.Element | JSX.Element[] | string | undefined | null;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AssetTypeComponentSelector: FC<Props> = ({ IfRealEstate, IfPowerplant, IfPlot, children }) => {
  const { assetType } = useAssetType();

  if (assetType === 'plot') return <IfPlot>{children}</IfPlot>;

  if (assetType === 'powerplant' || assetType === 'citizenParticipationLoan') return <IfPowerplant>{children}</IfPowerplant>;

  if (assetType === 'realEstate' || assetType === 'builderOwnerModel') return <IfRealEstate>{children}</IfRealEstate>;

  return <IfRealEstate>{children}</IfRealEstate>;
};
